import { useState } from 'react';

import { RowSelectionState, Updater } from '@tanstack/react-table';

import { callOrReturn } from '@adsk/alloy-react-helpers';

export const useSelection = (
  onRowSelectionChange?: (sorting: RowSelectionState) => void,
) => {
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});

  return {
    selectionState: { rowSelection },
    selectionOptions: {
      enableRowSelection: true,
      enableMultiRowSelection: false,
      onRowSelectionChange: (updaterOrValue: Updater<RowSelectionState>) => {
        setRowSelection((oldState) => {
          const newState = callOrReturn<Updater<RowSelectionState>>(
            updaterOrValue,
            oldState,
          );
          onRowSelectionChange?.(newState);
          return newState;
        });
      },
    },
  };
};
